import React from 'react';
import { Box, List, ListItem, ListItemText, Checkbox, TextField } from '@mui/material';

const ProductSelectionStep = ({ products, newBundle, setNewBundle, searchQuery, setSearchQuery }) => {
    // Filter products based on search query
    const filteredProducts = products.filter(product =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const findChild = (productId) => newBundle.productIds.find(c => c.productId === productId);

    const toggleProduct = (productId) => {
        setNewBundle(prev => ({
            ...prev,
            productIds: findChild(productId)
                ? prev.productIds.filter(c => c.productId !== productId)
                : [...prev.productIds, { productId, qty: 1 }],
        }));
    };

    const updateQty = (productId, qty) => {
        const parsedQty = Math.max(1, parseInt(qty, 10) || 1);
        setNewBundle(prev => ({
            ...prev,
            productIds: prev.productIds.map(c => c.productId === productId ? { ...c, qty: parsedQty } : c),
        }));
    };

    return (
        <Box sx={{ width: '100%' }}>
            <TextField
                fullWidth
                label="Search Products"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                margin="normal"
            />
            <List sx={{ maxHeight: 400, overflow: 'auto' }}>
                {filteredProducts.map((product) => {
                    const child = findChild(product.id);
                    return (
                        <ListItem key={product.id} divider>
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
                                <img
                                    src={product.smallThumbnailUrl || 'https://placehold.co/50'}
                                    alt={product.name}
                                    style={{ width: '50px', height: '50px', objectFit: 'cover', marginRight: '16px' }}
                                />
                                <ListItemText
                                    primary={product.name}
                                    secondary={`Price: ${product.defaultDisplayedPriceFormatted}`}
                                />
                                {child && (
                                    <TextField
                                        type="number"
                                        size="small"
                                        label="Qty"
                                        value={child.qty}
                                        onChange={(e) => updateQty(product.id, e.target.value)}
                                        onClick={(e) => e.stopPropagation()}
                                        inputProps={{ min: 1 }}
                                        sx={{ width: 90 }}
                                    />
                                )}
                                <Checkbox
                                    checked={Boolean(child)}
                                    onChange={() => toggleProduct(product.id)}
                                />
                            </Box>
                        </ListItem>
                    );
                })}
            </List>
        </Box>
    );
};

export default ProductSelectionStep;
